/** Deep-water Gerstner wave set driven by wind, with phases wrapped on the CPU (double precision). Pure. */
export interface Wave {
  /** Unit travel direction on the ground plane (x = east… scene frame x, z). */
  dir: [number, number];
  wavelength: number;
  amplitude: number;
  omega: number;
}

const G = 9.81;
const WAVELENGTHS = [34, 19, 9.5, 4.6];
const SPREAD_DEG = [0, 28, -22, 47];

/** windFromDeg: direction the wind comes FROM, in scene-frame degrees (0 = -Z, 90 = +X). */
export function waveSet(windSpeedMs: number, windFromDeg: number): Wave[] {
  const wind = Math.max(0, windSpeedMs);
  return WAVELENGTHS.map((wl, i) => {
    const toRad = ((windFromDeg + 180 + SPREAD_DEG[i]!) * Math.PI) / 180;
    const k = (2 * Math.PI) / wl;
    return {
      dir: [Math.sin(toRad), -Math.cos(toRad)],
      wavelength: wl,
      amplitude: wl * (0.004 + 0.0022 * Math.min(wind, 15)),
      omega: Math.sqrt(G * k),
    };
  });
}

/** omega·t per wave, wrapped into [0, 2π): the shader never multiplies a ~1e9 s animTime in float32. */
export function wavePhases(waves: Wave[], animTime: number): number[] {
  const tau = 2 * Math.PI;
  return waves.map((w) => (((w.omega * animTime) % tau) + tau) % tau);
}

/** Specular roughness of the sea: narrow sun/moon path in calm air, wide and broken in wind. */
export function seaRoughness(windSpeedMs: number): number {
  return Math.min(0.35, 0.05 + 0.02 * Math.max(0, windSpeedMs));
}
